<template>
  <div class="empty-downloads">
    <div class="empty-icon" :style="{ color: $theme.primaryColor }">
      <IconMenuDownload />
    </div>
    <p class="empty-title">Nenhuma aula baixada ainda</p>
    <p class="empty-subtitle">Baixe suas aulas favoritas para assistir mesmo sem internet</p>
    <button
      class="empty-cta"
      :style="{ backgroundColor: $theme.primaryColor, color: $theme.primaryText }"
      @click="$router.push('/p/my-courses')"
    >Explorar cursos</button>
  </div>
</template>

<script>
import IconMenuDownload from '@/components/UI/IconMenuDownload.vue';

export default {
  name: 'EmptyDownloads',
  components: { IconMenuDownload }
};
</script>

<style scoped lang="scss">
.empty-downloads {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
}

.empty-icon {
  opacity: 0.6;
  margin-bottom: 16px;
  transform: scale(3);
}

.empty-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--md-text);
  margin: 24px 0 6px;
}

.empty-subtitle {
  font-size: 13px;
  color: var(--md-text-dim);
  margin: 0 0 24px;
  max-width: 280px;
}

.empty-cta {
  border: none;
  border-radius: 999px;
  padding: 10px 22px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
</style>
